import * as React from 'react'
import { useRouteError } from 'react-router'
import { ErrorState } from '@/components/PageState'
import { Button } from '@/components/ui/button'
import { reportRouteError } from '@/observability/sentry'

/**
 * Shown when a page throws while rendering, in place of React Router's bare
 * default. Reports the error (once per error) so it reaches Sentry: the
 * router catches render errors itself, so nothing else would.
 */
export function RouteErrorPage() {
  const error = useRouteError()
  React.useEffect(() => {
    reportRouteError(error)
  }, [error])
  return (
    <div className="flex min-h-svh items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-md space-y-3">
        <ErrorState message="Something went wrong on this page. It's been reported." />
        <Button variant="secondary" onClick={() => window.location.reload()}>
          Reload the page
        </Button>
      </div>
    </div>
  )
}
